import { render } from "./ReviewHeader.vue?vue&type=template&id=39e75ea7&ts=true"
import script from "./ReviewHeader.ts?vue&type=script&lang=ts&external"
export * from "./ReviewHeader.ts?vue&type=script&lang=ts&external"

import "./ReviewHeader.vue?vue&type=style&index=0&id=39e75ea7&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__